export default __webpack_public_path__ + "static/media/privacy.7ece0407.md";